<template>

 <scroll-page :pull-reload="true">
   
    <list-emails :group_id="id"/>
    
</scroll-page>

</template>

<script>

import { mapState } from 'vuex';
import ListEmails from '../components/emails/ListEmails.vue';
import ScrollPage from '../components/ScrollPage.vue';
import { USER_LEVEL } from '../settings/USER_LEVEL.js';

export default {
  name: 'emails-page',
  data:function(){
    return{
      id:this.$route.params.id, /* group id */
    }
  },
  computed:{
     ...mapState([
       'appSettings'
       ]),
       computeUserAccess(){
         
         if (this.appSettings.user_level==USER_LEVEL.NONE){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }
         return false;
       }
  },
  components: {
    ListEmails,
    ScrollPage,
  },
  methods:{ 
  },// methods{}
  created(){
    
    //this.group = this.groups.find(group => group.id === this.id);
    //this.download_id = this.group.id;
   
  }
}

    
    
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
